export enum ThemeType {
	default = 'default'
}

export const getThemeByValue = (value?: string | null) => {
	if (Object.values(ThemeType).includes(value as ThemeType)) {
		return value as ThemeType;
	} else {
		return ThemeType.default;
	}
};
